// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"SectionTitle_sectionTitle__1URi-"};